import { DefaultTheme } from 'styled-components';

const defaultTheme: DefaultTheme = {
  colors: {
    // Web colors
    white: '#ffffff',
    offWhite: '#FFFFFE',
    lightGrey: '#F5F4F4',
    grey: '#595959',
    nearlyBlack: '#222',
    deepBlack: '#070707',
    black: '#000',
    orangePeel: '#F90',

    // Brand colors
    coffee: '#1A1718',
    moss: '#7A7669',
    midGrey: '#989794',
    sandy: '#E3D9C6',

    // Added colors
    lineGrey: '#C0BCB8',
    bgGrey: '#EAEAEA',
    gradient: `linear-gradient(
      98deg,
      #f6f2eb 25.35%,
      #fff 46.13%,
      #f7f3ec 76.6%
    )`,
  },

  align: {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
  },

  justify: {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    even: 'space-evenly',
    around: 'space-around',
    between: 'space-between',
  },

  breakpoints: {
    xs: '320px',
    s: '576px',
    m: '768px',
    l: '820px',
    xl: '1200px',
    xxl: '1480px',
    xxxl: '1800px',
  },
};

export default defaultTheme;
